<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 21">
    <path
      d="M10.5 20.5C16.0228 20.5 20.5 16.0228 20.5 10.5C20.5 4.97715 16.0228 0.5 10.5 0.5C4.97715 0.5 0.5 4.97715 0.5 10.5C0.5 16.0228 4.97715 20.5 10.5 20.5Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.3333 5.8C12.3333 5.51997 12.3333 5.37996 12.2788 5.273C12.2309 5.17892 12.1544 5.10243 12.0603 5.0545C11.9534 5 11.8134 5 11.5333 5H9.46667C9.18664 5 9.04663 5 8.93967 5.0545C8.84559 5.10243 8.7691 5.17892 8.72116 5.273C8.66667 5.37996 8.66667 5.51997 8.66667 5.8V7.86667C8.66667 8.14669 8.66667 8.28671 8.61217 8.39366C8.56423 8.48774 8.48774 8.56423 8.39366 8.61217C8.28671 8.66667 8.14669 8.66667 7.86667 8.66667H5.8C5.51997 8.66667 5.37996 8.66667 5.273 8.72116C5.17892 8.7691 5.10243 8.84559 5.0545 8.93967C5 9.04663 5 9.18664 5 9.46667V11.5333C5 11.8134 5 11.9534 5.0545 12.0603C5.10243 12.1544 5.17892 12.2309 5.273 12.2788C5.37996 12.3333 5.51997 12.3333 5.8 12.3333H7.86667C8.14669 12.3333 8.28671 12.3333 8.39366 12.3878C8.48774 12.4358 8.56423 12.5123 8.61217 12.6063C8.66667 12.7133 8.66667 12.8533 8.66667 13.1333V15.2C8.66667 15.48 8.66667 15.62 8.72116 15.727C8.7691 15.8211 8.84559 15.8976 8.93967 15.9455C9.04663 16 9.18664 16 9.46667 16H11.5333C11.8134 16 11.9534 16 12.0603 15.9455C12.1544 15.8976 12.2309 15.8211 12.2788 15.727C12.3333 15.62 12.3333 15.48 12.3333 15.2V13.1333C12.3333 12.8533 12.3333 12.7133 12.3878 12.6063C12.4358 12.5123 12.5123 12.4358 12.6063 12.3878C12.7133 12.3333 12.8533 12.3333 13.1333 12.3333H15.2C15.48 12.3333 15.62 12.3333 15.727 12.2788C15.8211 12.2309 15.8976 12.1544 15.9455 12.0603C16 11.9534 16 11.8134 16 11.5333V9.46667C16 9.18664 16 9.04663 15.9455 8.93967C15.8976 8.84559 15.8211 8.7691 15.727 8.72116C15.62 8.66667 15.48 8.66667 15.2 8.66667H13.1333C12.8533 8.66667 12.7133 8.66667 12.6063 8.61217C12.5123 8.56423 12.4358 8.48774 12.3878 8.39366C12.3333 8.28671 12.3333 8.14669 12.3333 7.86667V5.8Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
